export const SALE_PAYMENT_TERMS_SELECT_FIELDS =
  "payment_condition_days, payment_condition_label, payment_due_date";

let salePaymentTermsColumnsAvailable = null;
const SALE_PAYMENT_TERMS_SUPPORT_KEY = "impulza_sales_payment_terms_support";

const readSalePaymentTermsColumnsSupport = () => {
  if (salePaymentTermsColumnsAvailable !== null) {
    return salePaymentTermsColumnsAvailable;
  }

  if (typeof window === "undefined") {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(
      SALE_PAYMENT_TERMS_SUPPORT_KEY,
    );
    if (rawValue === "true") {
      salePaymentTermsColumnsAvailable = true;
      return true;
    }
    if (rawValue === "false") {
      salePaymentTermsColumnsAvailable = false;
      return false;
    }
  } catch {
    // Ignore storage access issues and continue with runtime detection.
  }

  return null;
};

const writeSalePaymentTermsColumnsSupport = (value) => {
  salePaymentTermsColumnsAvailable = value;

  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      SALE_PAYMENT_TERMS_SUPPORT_KEY,
      value ? "true" : "false",
    );
  } catch {
    // Ignore storage access issues.
  }
};

export const getSalePaymentTermsColumnsSupport = () =>
  readSalePaymentTermsColumnsSupport();

export const setSalePaymentTermsColumnsSupport = (value) =>
  writeSalePaymentTermsColumnsSupport(Boolean(value));

export function isMissingSalePaymentTermsColumnsError(error) {
  const details = [error?.message, error?.details, error?.hint, error?.code]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    details.includes("payment_condition_days") ||
    details.includes("payment_condition_label") ||
    details.includes("payment_due_date")
  );
}

export function normalizeSalePaymentTermsRow(sale) {
  if (!sale) return sale;

  return {
    ...sale,
    payment_condition_days: sale.payment_condition_days ?? null,
    payment_condition_label: sale.payment_condition_label ?? null,
    payment_due_date: sale.payment_due_date ?? null,
  };
}
